module.exports = new __parcel__URL__("kitten4.7c25dd70.png").toString();